import { HttpClient } from '@adapters/HttpClient';

export interface TenantChild {
  id: number;
  name: string;
  parent_team_id: number;
}

interface TenantChildResponse {
  data?: TenantChild[];
}

export class TeamsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getTeamsChild(parentTeamId?: number): Promise<TenantChild[]> {
    const params = parentTeamId ? { parent_team_id: parentTeamId } : undefined;
    const response = await this.httpClient.get<TenantChildResponse | TenantChild[]>(
      '/teams-child',
      params
    );

    const list = Array.isArray(response)
      ? response
      : Array.isArray(response?.data)
        ? response.data
        : [];

    return list.map((item) => ({
      id: item.id,
      name: item.name,
      parent_team_id: item.parent_team_id,
    }));
  }
}

